export const icon = "fa-solid fa-route";
export const singleEntityName = "Servizio";
export const pluralEntityName = "Corse";
export const dateFormat = 'DD/MM/YYYY';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

type StatusColors = {
    [key: string]: string;
}

export const status_colors : StatusColors = {
    "TO_START": "#1BC5BD",
    "IN_PROGRESS": "#EEEA0D",
    "FINISHED": "transparent",
    "CANCELED": "#F64E60",
    "BILLED": "#0DA3EE",
    "PAID": "#0D44EE"
}
